/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC,useState,useEffect} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {
  LinkWidget,
  MixedWidget2,
  MixedWidget10,
  MixedWidget11,
  ListsWidget2,
  ListsWidget3,
  ListsWidget4,
  ListsWidget5,
  ListsWidget6,
  TablesWidget5,
  TablesWidget10,
  MixedWidget8,
} from '../../../_metronic/partials/widgets'

import { reducer } from '../../modules/auth'
import axios from 'axios'

const apiBase                             = 'https://pilotgarageonline.com/app/';
const apiKey                              = 'NT6xxEZzh6kBSRGzU4YaL2HLyZdxs6mm';
axios.defaults.baseURL                    = apiBase;
axios.defaults.headers['MOBIL-API-KEY']   = apiKey;




const DashboardPage: FC = () => (
  <>
    {/* begin::Row */}
    <div className='row'>
      <div className='col-md-3 mb-4'>        
        <LinkWidget
          className='card-xl-stretch d-flex align-items-center justify-content-center rounded shadow-sm linkWidget p-10'
          cardColor='#00d2d3'
          titleClass='fw-bolder text-white'
          title ='RANDEVULAR'
          link='randevular'
          count='0'
        />
      </div>
      <div className='col-md-3 mb-4'>        
        <LinkWidget
          className='card-xl-stretch d-flex align-items-center justify-content-center rounded shadow-sm linkWidget p-10'
          cardColor='#54a0ff'
          titleClass='fw-bolder text-white'
          title ='NÖBETÇİ NOTER'
          link='randevular'
          count=''
        />
      </div>
      <div className='col-md-3 mb-4'>        
        <LinkWidget
          className='card-xl-stretch d-flex align-items-center justify-content-center rounded shadow-sm linkWidget p-10'
          cardColor='#fc5c65'
          titleClass='fw-bolder text-white'
          title ='HIZLI TALEP'
          link='randevular'
          count=''
        />
      </div>
      <div className='col-md-3 mb-4'>        
        <LinkWidget
          className='card-xl-stretch d-flex align-items-center justify-content-center rounded shadow-sm linkWidget p-10'
          cardColor='#2e86de'
          titleClass='fw-bolder text-white'
          title ='MAĞAZA'
          link='randevular'
          count=''
        />
      </div>
      <div className='col-md-3 mb-4'>        
        <LinkWidget
          className='card-xl-stretch d-flex align-items-center justify-content-center rounded shadow-sm linkWidget p-10'
          cardColor='#ffffff'
          titleClass='fw-bolder text-dark'
          title ='HIZLI ARAÇ KAYIT'
          link='randevular'
          count=''
        />
      </div>
      <div className='col-md-3 mb-4'>        
        <LinkWidget
          className='card-xl-stretch d-flex align-items-center justify-content-center rounded shadow-sm linkWidget p-10'
          cardColor='#ffffff'
          titleClass='fw-bolder text-dark'
          title ='PİLOTGARAGE ARAÇ KAYDI'
          link='randevular'
          count=''
        />
      </div>
      <div className='col-md-3 mb-4'>        
        <LinkWidget
          className='card-xl-stretch d-flex align-items-center justify-content-center rounded shadow-sm linkWidget p-10'
          cardColor='#ffffff'
          titleClass='fw-bolder text-dark'
          title ='PİLOT KART ARAÇ KAYDI'
          link='randevular'
          count=''
        />
      </div>
      <div className='col-md-3 mb-4'>        
        <LinkWidget
          className='card-xl-stretch d-flex align-items-center justify-content-center rounded shadow-sm linkWidget p-10'
          cardColor='#ffffff'
          titleClass='fw-bolder text-dark'
          title ='CONTA YANIK TESTİ'
          link='randevular'
          count=''
        />
      </div>
      <div className='col-md-3 mb-4'>        
        <LinkWidget
          className='card-xl-stretch d-flex align-items-center justify-content-center rounded shadow-sm linkWidget p-10'
          cardColor='#ffffff'
          titleClass='fw-bolder text-dark'
          title ='HASAR & KM SORGU'
          link='randevular'
          count=''
        />
      </div>
      <div className='col-md-3 mb-4'>        
        <LinkWidget
          className='card-xl-stretch d-flex align-items-center justify-content-center rounded shadow-sm linkWidget p-10'
          cardColor='#ffffff'
          titleClass='fw-bolder text-dark'
          title ='BEKLEYEN EKSPERTİZLER'
          link='randevular'
          count=''
        />
      </div>
      <div className='col-md-3 mb-4'>        
        <LinkWidget
          className='card-xl-stretch d-flex align-items-center justify-content-center rounded shadow-sm linkWidget p-10'
          cardColor='#ffffff'
          titleClass='fw-bolder text-dark'
          title ='DEVAM EDEN EKSPERTİZLER'
          link='randevular'
          count=''
        />
      </div>
      <div className='col-md-3 mb-4'>        
        <LinkWidget
          className='card-xl-stretch d-flex align-items-center justify-content-center rounded shadow-sm linkWidget p-10'
          cardColor='#ffffff'
          titleClass='fw-bolder text-dark'
          title ='TÜM BAYİLERDE ARA'
          link='randevular'
          count=''
        />
      </div>
    </div>

  </>
)


const DashboardWrapper: FC = () => {

  

  const [servers,setServers] = useState([]);
  const getServers = async () => {
    const res = await axios.get('dealersList')
    await setServers(res.data)
  }
  console.log(JSON.stringify(servers));
  // console.log(JSON.stringify(servers));

  
  // axios.get('dealersList').then(function(response){
    // console.log(JSON.stringify(response.data.data));
  // })
  // .catch(function(err) {
      // console.log('ERROR: ', err)
  // })

  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
